import { VisuallyHidden } from '@radix-ui/react-visually-hidden';
import { ComponentProps } from 'react';
import {
  Modal,
  ModalCloseButton,
  ModalContent,
  ModalDescription,
  ModalTitle,
} from '../../../../../design-system/modal/modal';
import { TransactionView } from '../../../../../types/entity-types';
import { MarkAsPaidModalContent } from './mark-as-paid-modal-content';

type MarkAsPaidModalProps = {
  isOpen: boolean;
  invoiceInfo: ComponentProps<typeof MarkAsPaidModalContent>['invoiceInfo'];
  transactions: TransactionView[];
  selectedPaidTransactionId?: string;
  canMarkAsPaidWithoutMatching?: boolean;
  isMatching: boolean;
  isMarkingAsPaid: boolean;
  onClose: () => void;
  onToggleTransaction: (transactionId: string) => void;
  onMatchToTransaction: () => Promise<void>;
  onMarkAsPaidWithoutMatching: () => Promise<void>;
};

export const MarkAsPaidModal = ({
  isOpen,
  invoiceInfo,
  transactions,
  selectedPaidTransactionId,
  canMarkAsPaidWithoutMatching,
  isMatching,
  isMarkingAsPaid,
  onClose,
  onToggleTransaction,
  onMatchToTransaction,
  onMarkAsPaidWithoutMatching,
}: MarkAsPaidModalProps) => {
  return (
    <Modal open={isOpen} onOpenChange={onClose}>
      <ModalContent className="h-max w-[702px] p-7">
        <VisuallyHidden>
          <ModalTitle>Mark an invoice as paid</ModalTitle>

          <ModalDescription>Mark an invoice as paid</ModalDescription>
        </VisuallyHidden>

        <ModalCloseButton onClick={onClose} aria-label="Close modal" />

        <MarkAsPaidModalContent
          invoiceInfo={invoiceInfo}
          transactions={transactions}
          selectedPaidTransactionId={selectedPaidTransactionId}
          canMarkAsPaidWithoutMatching={canMarkAsPaidWithoutMatching}
          isMatching={isMatching}
          isMarkingAsPaid={isMarkingAsPaid}
          onToggleTransaction={onToggleTransaction}
          onMatchToTransaction={onMatchToTransaction}
          onMarkAsPaidWithoutMatching={onMarkAsPaidWithoutMatching}
        />
      </ModalContent>
    </Modal>
  );
};
